import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../../constants/common'
import { useScreen } from '../../../../../hooks'
import { BuildingMultiSelect } from '../../../../Building'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS } from '../../BuildingGroupForm.constants'

import * as styles from './BuildingsField.module.css'

function BuildingsField(props) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      {...props}
      multi
      Component={FormFieldSelectNG}
      Select={BuildingMultiSelect}
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('BuildingGroup.BuildingsFieldPlaceholderKey'),
          },
        },
      }}
      emptyValue={EMPTY_LIST}
      fieldComponentProps={{
        label: `${t('BuildingGroup.BuildingsFieldLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={BUILDING_GROUP_FORM_FIELD_NAME_BUILDINGS}
      tagsProps={{
        className: styles.buildingsFieldTags,
      }}
    />
  )
}

export default BuildingsField
